import { render, staticRenderFns } from "./PlatbandSidebarMenu.vue?vue&type=template&id=dfbb1db6&scoped=true&"
import script from "./PlatbandSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./PlatbandSidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./PlatbandSidebarMenu.vue?vue&type=style&index=0&id=dfbb1db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbb1db6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfbb1db6')) {
      api.createRecord('dfbb1db6', component.options)
    } else {
      api.reload('dfbb1db6', component.options)
    }
    module.hot.accept("./PlatbandSidebarMenu.vue?vue&type=template&id=dfbb1db6&scoped=true&", function () {
      api.rerender('dfbb1db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/PlatbandSidebarMenu.vue"
export default component.exports